import { render, staticRenderFns } from "./best-mask.component.vue?vue&type=template&id=6939404a&scoped=true"
import script from "./best-mask.component.vue?vue&type=script&lang=js"
export * from "./best-mask.component.vue?vue&type=script&lang=js"
import style0 from "./best-mask.component.vue?vue&type=style&index=0&id=6939404a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6939404a",
  null
  
)

export default component.exports